<ng-container *transloco="let t; read: 'org-settings-communication-workflow'">
  <app-communication-workflow-table-editor> </app-communication-workflow-table-editor>
</ng-container>
